import { isPreviewing } from 'studio5/lib/routing';
import { TemporaryBanner } from './Banners.styled';

type PreviewBannerProps = {
  previewing?: boolean;
};

export default function PreviewBanner({
  previewing = isPreviewing(),
}: PreviewBannerProps) {
  if (!previewing) {
    return null;
  }

  return (
    <TemporaryBanner aria-live="polite" role="status">
      Currently viewing preview build!
    </TemporaryBanner>
  );
}
